import { Menu, MenuItem } from "@material-ui/core";
import React, { useState } from "react";
import { AddLinkedRecordDialog } from "./AddLinkedRecordDialog";
import { linkedRecordTypeDefinitions } from "../domain/linkedRecordTypeDefinitions";
import { LinkedRecordsProps } from "./LinkedRecordsProps";
import { LinkedRecordTypeDefinition } from "../domain/LinkedRecordTypeDefinition";
import { useSelector } from "react-redux";
import { authSelector } from "../redux/selectors";

type AddLinkedRecordMenuProps = LinkedRecordsProps & {
  anchorEl: Element;
  onClose: () => void;
};

export const AddLinkedRecordMenu: React.FC<AddLinkedRecordMenuProps> = ({
  anchorEl,
  onClose,
  ...props
}) => {
  const [
    selectedDefinition,
    setSelectedDefinition,
  ] = useState<LinkedRecordTypeDefinition | null>(null);

  const handleSelectDefinition = (definition: LinkedRecordTypeDefinition) => {
    setSelectedDefinition(definition);
  };

  const handleDialogClose = () => {
    setSelectedDefinition(null);
    onClose();
  };

  const user = useSelector(authSelector);

  return (
    <>
      <Menu
        open={!!anchorEl}
        onClose={onClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        data-test="menu-selectLinkedRecordType"
      >
        {linkedRecordTypeDefinitions
          .filter(x => {
            if (!!x.allowAccess) {
              return (x.allowAccess(user))
            }
            return true;
          })
          .map((definition, index) => (
          <MenuItem
            key={definition.type}
            style={{ minWidth: anchorEl.clientWidth }}
            onClick={() => handleSelectDefinition(definition)}
          >
            {definition.label}
          </MenuItem>
        ))}
      </Menu>
      {selectedDefinition && (
        <AddLinkedRecordDialog
          definition={selectedDefinition}
          onClose={handleDialogClose}
          {...props}
        />
      )}
    </>
  );
};
